import Vue from 'vue';
import typedDefaults from '@/utils/helpers/typed-defaults';

const defaultTypes = {
  id: 0,
  name: '',
  color: '',
  projectId: 0,
};

export default {
  namespaced: true,
  state: {
    records: {},
  },
  mutations: {
    records(state, columns) {
      const newCols = {};
      columns.forEach((column) => {
        newCols[column.id] = typedDefaults(defaultTypes, column);
      });
      state.records = { ...state.records, ...newCols };
    },
    record(state, column) {
      const newCol = typedDefaults(defaultTypes, column);
      Vue.set(state.records, newCol.id, newCol);
    },
  },
};
